import axios from 'axios'
import { AuthModel } from './_models'

export const LOGIN_URL = `https://bayi.wisnet.com.tr/api/netway-auth/login`

// Server should return AuthModel
export function login(email: string, password: string, recaptcha_value: string) {
  // Dili al
  const lang: any = localStorage.getItem('i18nConfig')
  const langJSON = JSON.parse(lang)
  const headers = {
    'app-language': `${langJSON.selectedLang}`,
  }
  return axios.post<AuthModel>(
    LOGIN_URL,
    {
      email,
      password,
      recaptcha_value,
    },
    { headers: headers }
  )
}
